<template>
  <Modal v-model="modalVisible">
    <LoadingOverlay :value="loading" />
    <div class="team-modal">
      <div class="team-modal__title__container">
        <h2 class="team-modal__title">{{ modalContent.gw.name }} • {{ modalContent.gw.date }}</h2>
        <h4 class="team-modal__subtitle">
          {{ $t("message.COMPLETED_GW_PARTICIPATING_TEAM") }}{{ $t("message.TWO_DOTS") }} {{ modalContent.gw.teamName }}
        </h4>
      </div>
      <table v-if="modalContent.data.length" class="team-modal-array">
        <thead>
          <tr>
            <th />
            <th>{{ $t("message.COMPLETED_GW_NB_THIS_GW") }}</th>
            <th>{{ $t("message.COMPLETED_GW_NB_ALL_GW") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in modalContent.data" :key="i" class="team-modal-array__row">
            <td>
              <UserThumbnail
                v-if="user.id"
                :value="Number(user.id)"
                disabled
                fetch-data
                row
              />
              {{ user.firstName }} {{ user.lastName }}
            </td>
            <td>{{ user.nSameTemplate }}</td>
            <td>{{ user.nTotalGw }}</td>
          </tr>
        </tbody>
      </table>
      <div class="team-modal__empty" v-else>{{ $t("message.COMPLETED_GW_EMPTY") }}</div>
    </div>
  </Modal>
</template>

<script>
// Components
import LoadingOverlay from '@/components/loading-overlay.vue';
import Modal from '@/components/modal.vue';
import UserThumbnail from '@/components/user-thumbnail.vue';

export default {

  name: 'GwTeamRecapModal',

  components: {
    LoadingOverlay,
    Modal,
    UserThumbnail,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    modalContent: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isModalLoading: true,
      modalVisible: this.visible || false,
      loading: true,
      userDataState: this.$store.state.userData,
    };
  },

  watch: {
    modalVisible(newVal) {
      if (newVal === false) {
        this.$emit('toggleModal');
      }
    },
  },

  mounted() {
    if (this.modalContent !== null) {
      this.loading = false;
    }
  },
};

</script>

<style lang="scss" scoped>
.team-modal {
  &__empty {
    color: red;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  padding: 0 5%;
  &__title {
    margin-bottom: 0;
    &__container {
      text-align: center;
    }
  }
  &__subtitle {
    margin: 0;
    font-style: italic;
    font-weight: normal;
  }
  &-array {
    margin-top: 50px;
    width: 100%;
    overflow: auto;
    &__row {
      width: 100%;
      & > td {
        text-align: center;
        &:first-of-type {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          text-align: left;
          white-space: nowrap;
        }
      }

      .user-thumbnail {
        margin-right: 0.7rem;
      }
    }
    &__img {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      margin-right: 5px;
      object-fit: cover;
    }
  }
}
</style>
